import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { appStore } from './app/store';


const RootComponent = () => {

  const [isApiReady, setIsApiReady] = useState(false);

  const decryptPhoneAPI = async (hashedString) => {
    try {
      const response = await fetch(`https://apiv2.shwenarsin.com/api/decrypt-phone/${hashedString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.user_id || data.phone || data.decrypted_phone || '';
      
    } catch (err) {
      console.error("API decryption failed:", err);
      return "";
    }
  };

  useEffect(() => {
    const handlePhoneDecryption = async () => {
      try {
        
        const params = new URLSearchParams(window.location.search);
        const encryptedPhone = params.get("phone");

        console.log("encrypted phone", encryptedPhone);

        if (encryptedPhone) {
          const phone = await decryptPhoneAPI(encryptedPhone);
          
          if (phone) {
            localStorage.setItem("userId", phone);
          } else {
            console.warn("⚠️ Phone decryption returned empty string");
          }
        }
      } catch (error) {
        console.error("Error in phone decryption process:", error);
      } finally {
        setIsApiReady(true);
      }
    };

    handlePhoneDecryption();
  }, []);


  // Render the components conditionally based on the API readiness
  return (
    <React.StrictMode>
      <Provider store={appStore}>
        {/* {isApiReady ? <App /> : <InitialLoadingScreen />} */}
        <App />
      </Provider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);
